import { connect } from 'react-redux';

import {
  getAudioGenerationQueueStats,
  updateAudioGeneration,
} from './actionSagas';
import AudioGenerationQueue from './AudioGenerationQueue';
import { getAudioGenerationQueueData } from './selectors';

const mapStateToProps = (state) => ({
  audioGenerationQueueData: getAudioGenerationQueueData(state),
});

const mapDispatchToProps = (dispatch) => ({
  getQueueData: () => dispatch(getAudioGenerationQueueStats()),
  updateAudioGeneration: (action) => dispatch(updateAudioGeneration(action)),
});

const AudioGenerationQueueContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AudioGenerationQueue);

export default AudioGenerationQueueContainer;
